// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"694":"ed06a5dd","820":"32059ba2","845":"866fb48f"}[chunkId] + ".chunk.js";
};